import {
  addProductsToCurrentCartSucceededType,
  addToCurrentCartSucceededType,
  changeCurrentCartTypeSucceededType,
  deleteCurrentCartEntrySucceededType,
  deleteCurrentCartSucceededType,
  placeCurrentCartsSucceededType,
  setCartType,
  updateCurrentCartEntryQuantitySucceededType
} from '../../carts/cartsSlice';
import { select, take } from 'typed-redux-saga';
import { CartLoaderKey } from '../../../dataloaders/CartLoaderKey';
import { CartsCookie } from '../../../dataloaders/CartsCookie';
import Cookies from 'js-cookie';
import { actionChannel } from 'typed-redux-saga';
import { cartsCookieCookieName } from '../../../const';
import { hydrateType } from '@spa/lib/store/HydrateAction';
import selectCartsCookie from '../../carts/selectors/selectCartsCookie';

function* watchCurrentCartsCookieChangesSaga(): Generator {
  let previousCartsCookieCookieValue: string | undefined = Cookies.get(cartsCookieCookieName);
  const requestChan = yield* actionChannel([
    hydrateType,
    setCartType,
    addToCurrentCartSucceededType,
    addProductsToCurrentCartSucceededType,
    changeCurrentCartTypeSucceededType,
    placeCurrentCartsSucceededType,
    updateCurrentCartEntryQuantitySucceededType,
    deleteCurrentCartEntrySucceededType,
    deleteCurrentCartSucceededType
  ]);
  while (true) {
    yield* take(requestChan);
    const currentCartsCookie: CartsCookie = yield* select(selectCartsCookie);
    const isEveryCartNull: boolean = Object.values(currentCartsCookie).every(
      (cartLoaderKey: CartLoaderKey) => cartLoaderKey.cartId === null
    );
    const newCartsCookieCookieValue: string | undefined = isEveryCartNull
      ? undefined
      : JSON.stringify(currentCartsCookie);
    if (newCartsCookieCookieValue !== previousCartsCookieCookieValue) {
      if (newCartsCookieCookieValue === undefined) {
        Cookies.remove(cartsCookieCookieName);
      } else {
        Cookies.set(cartsCookieCookieName, newCartsCookieCookieValue, { expires: 30 });
      }
      previousCartsCookieCookieValue = newCartsCookieCookieValue;
    }
  }
}

export default watchCurrentCartsCookieChangesSaga;
